import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  practiceSpeaking: {
    defaultMessage: `Practice speaking`,
  },

  watchTheVideo: {
    defaultMessage: `Watch the video`,
  },
});
